export default __webpack_public_path__ + "static/bwtransport-4-394b0c24ba48242024a39ab8676203c9.png";